// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"f1bc45b4","143":"d4fe2632","393":"f3018433","424":"a97b5b28","533":"d4814aaf","651":"8325effe","690":"22e5a9a1","852":"d476e2d3","940":"eb8cbe09"}[chunkId] + ".chunk.js";
};